module.exports = __webpack_public_path__ + "static/media/b1-古镇概况.8e3b0b63.png";